import React, { Fragment } from "react";
import { TailSpin, Oval } from "react-loader-spinner";

interface IProps {
  isActive?: boolean;
  className?: object | undefined;
  isPageLoader?: boolean;
  loadingType?: "TailSpin" | "Oval";
  loadingColor?: string;
  loadingHeight?: number;
  loadingWidth?: number;
  children?: React.ReactNode;
}

const LoadingIndicator: React.FC<IProps> = (props: IProps) => {
  const {
    isActive = false,
    isPageLoader = false,
    loadingType = "TailSpin",
    loadingColor = "rgb(97, 93, 250)",
    loadingHeight = 60,
    loadingWidth = 60,
    children,
    className: propClassName,
  } = props;

  const className: object =
    propClassName === undefined ? { display: "flex", justifyContent: "center", alignItems: "center" } : propClassName;

  const pageLoaderStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 9999,
  };

  const LoaderComponent = loadingType === "TailSpin" ? TailSpin : Oval;

  return (
    <Fragment>
      {isActive && (
        <div style={isPageLoader ? pageLoaderStyle : className}>
          <LoaderComponent
            visible={true}
            height={loadingHeight}
            width={loadingWidth}
            color={loadingColor}
            ariaLabel={`${loadingType.toLowerCase()}-loading`}
          />
        </div>
      )}
      {children}
    </Fragment>
  );
};

export default LoadingIndicator;
